import { useState } from "react";
import { ReactComponent as StartSelected } from "../../assets/svg/StarGreen.svg";
import { ReactComponent as StartUnSelected } from "../../assets/svg/StarBlack.svg";

export function SondageStar({
    // saveProgress,
    setValueSondage,
    setAnimationClass,
    setIsComplet,
    valueSondage,
    setResult,
    result,
}) {
    const [colorStar, setColorStar] = useState(0);

    function HandleSelect(param) {
        setColorStar(param);

        // Sauvegarder la progression
        // saveProgress(updatedResult);

        setTimeout(() => {
            setAnimationClass("slideDown");
        }, 700);

        setTimeout(() => {
            setColorStar(0);
            setAnimationClass("slideToTop");
            if (valueSondage.length === result.length + 1) {
                setIsComplet(true);
            }
        }, 900);

        setTimeout(() => {
            setAnimationClass("slideUp");
            if (valueSondage.length < result.length - 1) {
                setValueSondage(valueSondage + 1);
            }
            const updatedResult = [...result, param];
            setResult(updatedResult);
        }, 1100);

        setTimeout(() => {
            setAnimationClass("");
        }, 2100);
    }

    return (
        <>
            {Array.from({ length: 5 }, (_, index) => {
                return (
                    <div
                        key={index}
                        className={
                            colorStar === index + 1
                                ? "blinking"
                                : colorStar > index + 1
                                ? "selected"
                                : "unselected"
                        }
                    >
                        {colorStar >= index + 1 ? (
                            <StartSelected
                                fill={"#FCA62F"}
                                onClick={() => HandleSelect(index + 1)}
                            />
                        ) : (
                            <StartUnSelected
                                onClick={() => HandleSelect(index + 1)}
                            />
                        )}
                        <p>{index + 1}</p>
                    </div>
                );
            })}
        </>
    );
}
